import styled from "styled-components";

const MyDiv = styled.div`
  .page_wrapper {
    padding: 16px 20px;
  }

  .stat-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
    }
  }

  .stat-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }

  .avatar-badge {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 13px;
    background: #e0f2fe;
    color: #0369a1;
    flex-shrink: 0;
  }

  .status-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
  }

  .status-pill.approved {
    background: #dcfce7;
    color: #15803d;
    border: 1px solid #bbf7d0;
  }

  .status-pill.pending {
    background: #fef3c7;
    color: #b45309;
    border: 1px solid #fde68a;
  }

  .status-pill.rejected {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
  }

  /* Target CRM & Access Design */
  .crm-table-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 130px;
    max-width: 190px;
  }

  .crm-system-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    width: fit-content;
  }

  .crm-status-granted {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #ecfdf5;
    color: #065f46;
    border: 1px solid #a7f3d0;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    width: fit-content;
  }

  .crm-status-pending {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #fffbeb;
    color: #92400e;
    border: 1px solid #fde68a;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    width: fit-content;
  }

  .crm-id-code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 10.5px;
    color: #047857;
    background: #f0fdf4;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px dashed #6ee7b7;
    display: inline-block;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Modal Pipeline Card */
  .crm-pipeline-card {
    background: linear-gradient(135deg, #f0fdf4 0%, #f8fafc 100%);
    border: 1px solid #bbf7d0;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 104, 56, 0.06);
  }

  .pipeline-steps-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 12px;
  }

  .pipeline-step-item {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    transition: all 0.2s ease;

    &.completed {
      border-color: #86efac;
      background: #f0fdf4;
    }

    &.waiting {
      border-color: #fed7aa;
      background: #fffbeb;
    }

    &.rejected {
      border-color: #fca5a5;
      background: #fef2f2;
    }
  }

  .filter-tab-btn {
    border-radius: 8px;
    font-weight: 500;
    font-size: 13px;
    transition: all 0.2s ease;
  }

  .timeline-box {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 12px 14px;
    background: #f8fafc;
  }

  .approval-btn {
    transition: all 0.2s ease;
    &:hover {
      transform: translateY(-1px);
    }
  }

  .validation-error-text {
    font-size: 12px;
    color: #e11d48;
    font-weight: 500;
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
  }



  .crm-status-failed {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    width: fit-content;
  }

  .crm-diagnostics-btn {
    font-size: 11px;
    font-weight: 600;
    color: #0369a1;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 6px;
    border-radius: 4px;
    background: #f0f9ff;
    border: 1px solid #bae6fd;
    transition: all 0.2s ease;

    &:hover {
      background: #e0f2fe;
      border-color: #7dd3fc;
    }
  }

  .diagnostics-json-box {
    background: #0f172a;
    color: #f1f5f9;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11.5px;
    line-height: 1.5;
    padding: 12px;
    border-radius: 8px;
    max-height: 260px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-all;
    border: 1px solid #1e293b;
  }
    `;


  // .dossier-card {
  //   background: #ffffff;
  //   border: 1px solid #e2e8f0;
  //   border-radius: 12px;
  //   padding: 16px;
  //   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  // }

  // .dossier-badge-completed {
  //   display: inline-flex;
  //   align-items: center;
  //   gap: 6px;
  //   background: #ecfdf5;
  //   color: #065f46;
  //   border: 1px solid #a7f3d0;
  //   padding: 6px 12px;
  //   border-radius: 8px;
  //   font-size: 13px;
  //   font-weight: 600;
  // }

  // .crm-pill-active {
  //   display: inline-flex;
  //   align-items: center;
  //   gap: 4px;
  //   background: #ecfdf5;
  //   color: #15803d;
  //   border: 1px solid #bbf7d0;
  //   padding: 2px 7px;
  //   border-radius: 5px;
  //   font-size: 10.5px;
  //   font-weight: 600;
  // }

  // .crm-pill-failed {
  //   display: inline-flex;
  //   align-items: center;
  //   gap: 4px;
  //   background: #fef2f2;
  //   color: #dc2626;
  //   border: 1px solid #fecaca;
  //   padding: 2px 7px;
  //   border-radius: 5px;
  //   font-size: 10.5px;
  //   font-weight: 600;
  // }

  // .crm-pill-waiting {
  //   display: inline-flex;
  //   align-items: center;
  //   gap: 4px;
  //   background: #f8fafc;
  //   color: #64748b;
  //   border: 1px solid #e2e8f0;
  //   padding: 2px 7px;
  //   border-radius: 5px;
  //   font-size: 10.5px;
  //   font-weight: 500;
  // }

export default MyDiv;
